import React, { Fragment } from "react"
import classNames from "classnames"
import { isMac } from "@nova/util-browser"
import { ExtraSmallIcon, IconComponent } from "@nova/component-icons"

export type KeyboardShortcut = {
    title: string
    mac: (string | IconComponent)[]
    windows: (string | IconComponent)[]
}

export const KeyboardShortcuts = ({ shortcuts }: { shortcuts: KeyboardShortcut[] }) => {
    const isMacOS = isMac()
    return (
        <div className="relative flex flex-col gap-1 w-full select-none text-gray-100">
            {shortcuts.map((shortcut, i) => (
                <div key={i} className="h-5">
                    <h5>{shortcut.title}</h5>
                </div>
            ))}

            <div className="absolute top-0 right-0 flex flex-col gap-1">
                {shortcuts.map((shortcut, i) => {
                    const keys = isMacOS ? shortcut.mac : shortcut.windows
                    return (
                        <div key={i} className="h-5 flex items-center">
                            {keys.map((key, j) => (
                                <Fragment key={j}>
                                    {j > 0 && <small className="xs ml-0.5 mr-px -mt-px">+</small>}
                                    {typeof key === "string" ? (
                                        <div
                                            className={classNames(
                                                "h-5 bg-gray-700 flex items-center justify-center px-1",
                                                {
                                                    "w-5": key.length === 1,
                                                }
                                            )}
                                            style={{ borderRadius: "0.25rem" }}
                                        >
                                            {key}
                                        </div>
                                    ) : (
                                        <div
                                            className="bg-gray-700 w-5 h-5 flex items-center justify-center"
                                            style={{ borderRadius: "0.25rem" }}
                                        >
                                            <ExtraSmallIcon Icon={key as IconComponent} />
                                        </div>
                                    )}
                                </Fragment>
                            ))}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
